import React, { useEffect, useRef } from "react";

const InjiraBackground = ({ children, style = {} }) => {
  const particlesRef = useRef(null);

  useEffect(() => {
    const container = particlesRef.current;
    if (!container) return;
    const colors = ["#52b788","#74c69d","#40916c","#5dade2","#aed6f1","#95d5b2"];
    for (let i = 0; i < 35; i++) {
      const p = document.createElement("div");
      const size = Math.random() * 3 + 1;
      const duration = Math.random() * 20 + 15;
      const delay = Math.random() * 20;
      const drift = (Math.random() - 0.5) * 200;
      const color = colors[Math.floor(Math.random() * colors.length)];
      p.style.cssText = `
        position:absolute; border-radius:50%;
        width:${size}px; height:${size}px;
        left:${Math.random()*100}%;
        background:${color};
        box-shadow:0 0 ${size*3}px ${color};
        animation:injira-float ${duration}s linear -${delay}s infinite;
        --drift:${drift}px;
        opacity:0;
      `;
      container.appendChild(p);
    }
    return () => { container.innerHTML = ""; };
  }, []);

  return (
    <div style={{ position: "relative", width: "100%", height: "100%", overflow: "hidden", ...style }}>
      <style>{`
        @keyframes injira-float {
          0%   { transform:translateY(100vh) translateX(0); opacity:0; }
          10%  { opacity:1; }
          90%  { opacity:0.6; }
          100% { transform:translateY(-10vh) translateX(var(--drift)); opacity:0; }
        }
        @keyframes injira-pulse {
          0%,100% { r:3; opacity:0.4; }
          50%      { r:5; opacity:0.9; }
        }
        @keyframes injira-draw {
          0%   { stroke-dashoffset:300; opacity:0; }
          20%  { opacity:0.6; }
          80%  { opacity:0.4; }
          100% { stroke-dashoffset:0; opacity:0; }
        }
      `}</style>

      {/* Base gradient */}
      <div style={{
        position:"absolute", inset:0,
        background:`
          radial-gradient(ellipse 120% 80% at 50% 110%,
            #1a4a2e 0%, #2d6a4f 25%, #40916c 45%,
            #52b788 60%, #74c69d 72%, #95d5b2 80%,
            #b7e4c7 88%, #d8f3dc 94%, transparent 100%),
          linear-gradient(175deg,
            #0a1628 0%, #0d2137 15%, #0f3460 30%,
            #1a5276 45%, #1e6091 55%, #2980b9 68%,
            #5dade2 80%, #aed6f1 90%, #d6eaf8 100%)`
      }}/>

      {/* Hills SVG */}
      <svg style={{position:"absolute",inset:0,width:"100%",height:"100%"}}
           viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice">
        <defs>
          <filter id="ib-blur1"><feGaussianBlur stdDeviation="8"/></filter>
          <filter id="ib-blur2"><feGaussianBlur stdDeviation="4"/></filter>
          <filter id="ib-blur3"><feGaussianBlur stdDeviation="1.5"/></filter>
          <filter id="ib-glow">
            <feGaussianBlur stdDeviation="2" result="b"/>
            <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
          <linearGradient id="ib-hf" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#2d6a4f" stopOpacity="0.6"/>
            <stop offset="100%" stopColor="#1a4a2e" stopOpacity="0.9"/>
          </linearGradient>
          <linearGradient id="ib-hm" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#40916c" stopOpacity="0.75"/>
            <stop offset="100%" stopColor="#2d6a4f" stopOpacity="1"/>
          </linearGradient>
          <linearGradient id="ib-hn" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#52b788" stopOpacity="0.85"/>
            <stop offset="100%" stopColor="#1b4332" stopOpacity="1"/>
          </linearGradient>
          <linearGradient id="ib-hfr" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#74c69d" stopOpacity="0.9"/>
            <stop offset="100%" stopColor="#081c15" stopOpacity="1"/>
          </linearGradient>
          <radialGradient id="ib-sun" cx="50%" cy="35%" r="30%">
            <stop offset="0%" stopColor="#ffd166" stopOpacity="0.25"/>
            <stop offset="40%" stopColor="#06d6a0" stopOpacity="0.08"/>
            <stop offset="100%" stopColor="transparent" stopOpacity="0"/>
          </radialGradient>
        </defs>
        <ellipse cx="720" cy="280" rx="300" ry="200" fill="url(#ib-sun)"/>
        <g filter="url(#ib-blur1)" opacity="0.7">
          <path d="M0,520 C80,440 160,400 240,420 C320,440 380,380 460,360 C540,340 600,370 680,350 C760,330 820,300 900,320 C980,340 1040,380 1120,360 C1200,340 1280,380 1360,400 L1440,420 L1440,900 L0,900 Z" fill="url(#ib-hf)"/>
        </g>
        <g filter="url(#ib-blur2)" opacity="0.8">
          <path d="M0,580 C60,520 140,490 220,510 C300,530 360,480 440,460 C520,440 580,470 660,450 C740,430 800,400 880,420 C960,440 1020,480 1100,460 C1180,440 1260,490 1340,510 L1440,530 L1440,900 L0,900 Z" fill="url(#ib-hm)"/>
        </g>
        <g filter="url(#ib-blur3)" opacity="0.9">
          <path d="M0,650 C100,590 200,560 300,580 C400,600 460,550 560,530 C660,510 720,545 820,525 C920,505 980,540 1080,555 C1180,570 1280,545 1380,560 L1440,570 L1440,900 L0,900 Z" fill="url(#ib-hn)"/>
        </g>
        <path d="M0,760 C120,710 240,690 360,710 C480,730 560,700 680,690 C800,680 880,705 1000,715 C1120,725 1240,700 1360,715 L1440,720 L1440,900 L0,900 Z" fill="url(#ib-hfr)" opacity="0.95"/>
        {/* Trees */}
        <g opacity="0.6" fill="#1b4332">
          <ellipse cx="150" cy="648" rx="18" ry="28"/><rect x="147" y="648" width="6" height="15"/>
          <ellipse cx="185" cy="642" rx="14" ry="22"/><rect x="182" y="642" width="5" height="12"/>
          <ellipse cx="215" cy="650" rx="16" ry="25"/><rect x="212" y="650" width="5" height="14"/>
          <ellipse cx="1050" cy="538" rx="16" ry="26"/><rect x="1047" y="538" width="5" height="14"/>
          <ellipse cx="1080" cy="532" rx="13" ry="21"/><rect x="1077" y="532" width="5" height="12"/>
          <ellipse cx="1105" cy="540" rx="15" ry="24"/><rect x="1102" y="540" width="5" height="13"/>
        </g>
        {/* Network lines */}
        <g filter="url(#ib-glow)" stroke="#52b788" strokeWidth="0.8" fill="none" opacity="0.18">
          <line x1="200" y1="300" x2="400" y2="250" strokeDasharray="300" style={{animation:"injira-draw 6s ease-in-out 0s infinite"}}/>
          <line x1="400" y1="250" x2="650" y2="320" strokeDasharray="300" style={{animation:"injira-draw 6s ease-in-out 1s infinite"}}/>
          <line x1="650" y1="320" x2="850" y2="270" strokeDasharray="300" style={{animation:"injira-draw 6s ease-in-out 2s infinite"}}/>
          <line x1="850" y1="270" x2="1100" y2="310" strokeDasharray="300" style={{animation:"injira-draw 6s ease-in-out 0.5s infinite"}}/>
          <line x1="1100" y1="310" x2="1280" y2="260" strokeDasharray="300" style={{animation:"injira-draw 6s ease-in-out 1.5s infinite"}}/>
          <line x1="400" y1="250" x2="500" y2="180" strokeDasharray="200" style={{animation:"injira-draw 8s ease-in-out 3s infinite"}}/>
          <line x1="650" y1="320" x2="720" y2="200" strokeDasharray="200" style={{animation:"injira-draw 8s ease-in-out 4s infinite"}}/>
        </g>
        <g fill="#74c69d" filter="url(#ib-glow)" opacity="0.18">
          {[{cx:200,cy:300},{cx:400,cy:250},{cx:650,cy:320},{cx:850,cy:270},{cx:1100,cy:310},{cx:1280,cy:260},{cx:500,cy:180},{cx:720,cy:200}].map((n,i)=>(
            <circle key={i} cx={n.cx} cy={n.cy} r="3" style={{animation:`injira-pulse 3s ease-in-out ${i*0.5}s infinite`}}/>
          ))}
        </g>
      </svg>

      {/* Mist */}
      <div style={{position:"absolute",inset:0,background:`
        radial-gradient(ellipse 100% 40% at 50% 65%, rgba(255,255,255,0.12) 0%, transparent 70%),
        radial-gradient(ellipse 60% 30% at 20% 70%, rgba(180,220,200,0.15) 0%, transparent 60%),
        radial-gradient(ellipse 60% 30% at 80% 72%, rgba(160,210,230,0.12) 0%, transparent 60%)`}}/>

      {/* Blue overlay */}
      <div style={{position:"absolute",inset:0,background:`linear-gradient(180deg,
        rgba(10,22,60,0.55) 0%, rgba(15,52,96,0.35) 30%,
        rgba(20,80,60,0.15) 60%, rgba(10,40,25,0.45) 100%)`}}/>

      {/* Vignette */}
      <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse 100% 100% at 50% 50%, transparent 40%, rgba(5,10,20,0.5) 100%)`}}/>

      {/* Particles */}
      <div ref={particlesRef} style={{position:"absolute",inset:0,overflow:"hidden"}}/>

      {/* Content */}
      <div style={{position:"relative",zIndex:10,width:"100%",height:"100%"}}>
        {children}
      </div>
    </div>
  );
};

export default InjiraBackground;
